
import React, { useContext } from 'react';

import Context from "../context/context";
import FilterCount from "./FilterCount";



function SideFiltersNavItem(props){
    const {data, handleClick} = props;
    const {activeFilters} = useContext(Context);

    let selected = false;
    if (data.name === activeFilters.active_side_filter){
      selected = true;
    }

    return (
        <>
          <div
            className={`side-nav-item ${selected ? "active" : ""}`}
            onClick={() => handleClick()}
          >
            <span className="side-nav-item-title">

            <span className="side-nav-item-counter">{data.title}
            <FilterCount name={data.name}/></span>
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none">
            <path d="M2 8L5 5L2 2" stroke="white" stroke-width="2" stroke-linecap="square"/>
            </svg>
            </span>

          </div>
        </>
    )
}

export default SideFiltersNavItem;
